/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { SxProps, Theme } from '@mui/material';

export const loginContainerSX = ({ isMobile }: { isMobile?: boolean }): SxProps<Theme> => ({
	mt: { md: '71px', xs: '0px' },
	pt: { md: '31px', xs: '142px' },
	pb: { md: '31px', xs: '20px' },
	px: isMobile ? '14px' : '44px',
	boxShadow: 'none',
	borderRadius: '4px',
	opacity: 1,
	backgroundColor: isMobile ? '#FBFBFC' : '#ffffff',
});

export const loginContainerHomeSX = ({
	isMobile,
	marginBottom,
}: {
	isMobile?: boolean;
	marginBottom?: string;
}): SxProps<Theme> => ({
	mt: { md: '80px', xs: '0px' },
	mb: marginBottom ? marginBottom : undefined,
	pt: { md: '31px', xs: '40px' },
	pb: { md: '29px', xs: '20px' },
	px: isMobile ? '14px' : '44px',
	boxShadow: 'none',
	borderRadius: '4px',
	opacity: 1,
	backgroundColor: isMobile ? '#FBFBFC' : '#ffffff',
});

export const createAccountContainerSX = ({ isMobile }: { isMobile?: boolean }): SxProps<Theme> => ({
	mb: { md: '32px', xs: '40px' },
	boxShadow: 'none',
	backgroundColor: 'transparent',
	pt: isMobile ? '0px' : '17px',
	pb: isMobile ? '0px' : '0px',
	px: isMobile ? '14px' : '44px',
});
